import Vue from 'vue'

export function objectFill (target, reference) {
    for (const prop in reference) {
        if (typeof reference[prop] === 'object' && typeof target[prop] !== 'undefined') {
            if (reference[prop]) {
                target[prop] = reference[prop]
            }
        } else {
            if (target.hasOwnProperty(prop)) {
                target[prop] = reference[prop]
            }
        }
    }
    return target
}

Vue.mixin({
    methods: {
        objectFill
    }
})
